import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

/* global IntersectionObserver, CustomEvent, setTimeout */
var dispatchAppearEvent = function dispatchAppearEvent(entry) {
  var observer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (!window.Futurism) {
    return function () {
      setTimeout(function () {
        return dispatchAppearEvent(entry, observer)();
      }, 1);
    };
  }

  var target = entry.target ? entry.target : entry;
  var evt = new CustomEvent('futurism:appear', {
    bubbles: true,
    detail: {
      target: target,
      observer: observer
    }
  });
  return function () {
    target.dispatchEvent(evt);
  };
}; // from https://advancedweb.hu/how-to-implement-an-exponential-backoff-retry-strategy-in-javascript/#rejection-based-retrying


var wait = function wait(ms) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, ms);
  });
};

var callWithRetry = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(fn) {
    var depth,
        _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            depth = _args.length > 1 && _args[1] !== undefined ? _args[1] : 0;
            _context.prev = 1;
            _context.next = 4;
            return fn();

          case 4:
            return _context.abrupt("return", _context.sent);

          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](1);

            if (!(depth > 10)) {
              _context.next = 11;
              break;
            }

            throw _context.t0;

          case 11:
            _context.next = 13;
            return wait(Math.pow(1.15, depth) * 2000);

          case 13:
            return _context.abrupt("return", callWithRetry(fn, depth + 1));

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 7]]);
  }));

  return function callWithRetry(_x) {
    return _ref.apply(this, arguments);
  };
}();

var observerCallback = function observerCallback(entries, observer) {
  entries.forEach( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(entry) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (entry.isIntersecting) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return");

            case 2:
              _context2.next = 4;
              return callWithRetry(dispatchAppearEvent(entry, observer));

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }());
};

export var extendElementWithIntersectionObserver = function extendElementWithIntersectionObserver(element) {
  Object.assign(element, {
    observer: new IntersectionObserver(observerCallback.bind(element), {})
  });

  if (!element.hasAttribute('keep')) {
    element.observer.observe(element);
  }
};
export var extendElementWithEagerLoading = function extendElementWithEagerLoading(element) {
  if (element.dataset.eager === 'true') {
    if (element.observer) element.observer.disconnect();
    dispatchAppearEvent(element);
  }
};